export default __webpack_public_path__ + "static/168-c8c8090c3c73a69c25ffeee70cbd1c82.jpg";